import { OrganizationTeamMember } from "~/common/utils";
import { PROVIDER_SCHEDULE_METHODS } from "~/providers/constants/teamMembers";
import {
  CalendarScheduleMethod,
  EmailScheduleMethod,
  PhoneScheduleMethod,
  ProviderScheduleMethods,
} from "~/providers/types/teamMembers";

interface ProviderScheduleMethodMap {
  [PROVIDER_SCHEDULE_METHODS.PHONE]: PhoneScheduleMethod;
  [PROVIDER_SCHEDULE_METHODS.EMAIL]: EmailScheduleMethod;
  [PROVIDER_SCHEDULE_METHODS.CALENDAR]: CalendarScheduleMethod;
}

export function getProviderSchedulingMethodByType<
  T extends ProviderScheduleMethods,
>(
  type: T,
  provider?: OrganizationTeamMember,
): ProviderScheduleMethodMap[T] | null {
  return (
    provider?.contact_details?.find(
      (method): method is ProviderScheduleMethodMap[T] => method.type === type,
    ) ?? null
  );
}
